import "vite/modulepreload-polyfill";
import Pace from "pace-js";
import ClipboardJS from "clipboard";
import Glide from "@glidejs/glide";
import "./scss/index.scss"; // Utility function to preload images
import lottie from "lottie-web";
import Lenis from "lenis";
import ModalVideo from "modal-video";
import "modal-video/css/modal-video.min.css";
const BODY_LOADED_CLASS = "energized";
const MENU_OPEN_CLASS = "menu-open";

const body = document.querySelector("body");

document.addEventListener("DOMContentLoaded", () => {
  const lenis = new Lenis({
    autoRaf: true,
  });

  function isMobile() {
    return window.innerWidth < 768;
  }

  document.querySelectorAll(".video-trigger").forEach((el) => {
    console.log(el, el.getAttribute("data-video-src"));
    new ModalVideo([el], {
      url: el.getAttribute("data-video-src"),
      channel: "custom",
      autoplay: true,
    });
  });

  // on resize, if we're not on mobile, remove the menu-open class
  window.addEventListener("resize", () => {
    if (window.innerWidth >= 768) {
      if (body.classList.contains(MENU_OPEN_CLASS)) {
        body.classList.remove(MENU_OPEN_CLASS);

        lenis.start();

        const header = document.querySelector(".header");
        // check if the header has a theme-dark class
        if (header.getAttribute("data-theme") === "dark") {
          header.classList.remove("theme--`light`");
          header.classList.add("theme--dark");
        }
      }
    }
  });

  document.querySelectorAll(".hamburger").forEach((toggle) => {
    if (toggle.classList.contains("handled")) {
      return;
    }

    toggle.addEventListener("click", (e) => {
      e.preventDefault();

      toggle.classList.toggle("is-active");
      body.classList.toggle(MENU_OPEN_CLASS);

      if (body.classList.contains(MENU_OPEN_CLASS)) {
        lenis.stop();
      } else {
        lenis.start();
      }

      // if is-active then make sure the header does not have a theme-dark class
      // it should always have a theme-light class. If we're closing the menu
      // then we may need to restore the theme-dark class
      const header = document.querySelector(".header");

      if (toggle.classList.contains("is-active")) {
        if (header.classList.contains("theme--dark")) {
          header.setAttribute("data-theme", "dark");
        }

        header.classList.remove("theme--dark");
        header.classList.add("theme--light");
      } else {
        // check if the header has a theme-dark class
        if (header.getAttribute("data-theme") === "dark") {
          header.classList.remove("theme--`light`");
          header.classList.add("theme--dark");
        }
      }

      return false;
    });
  });

  /* clipboard */
  const clippy = new ClipboardJS(".clipboard", {
    text: function (trigger) {
      return trigger.getAttribute("data-clipboard-text");
    },
  });

  clippy.on("success", function (e) {
    e.trigger.classList.add("is-copied");
  });

  const dotsSync = (glideInstance, dots) => {
    const updateDots = (index) => {
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    };

    glideInstance.on("run.before", () => {
      const currentIndex = glideInstance.index;
      updateDots(currentIndex);
    });
    glideInstance.on("run.after", () => {
      const currentIndex = glideInstance.index;
      updateDots(currentIndex);
    });

    updateDots(glideInstance.index);
  };

  /**
   * Lottie
   */
  if (document.querySelector(".lottie")) {
    let dotLottie = null;

    const mobileAnimation = {
      autoplay: true,
      loop: false,
      speed: 1.5,
      renderer: "svg",
      container: document.querySelector("#dotlottie-canvas-mobile"),
      path: "/home-lottie-mobile.json",
    };

    const desktopAnimation = {
      autoplay: true,
      loop: false,
      speed: 1.25,
      renderer: "svg",
      container: document.querySelector("#dotlottie-canvas"),
      path: "/home-lottie-desktop.json",
    };

    let hasLoaded = "mobile";

    if (isMobile()) {
      dotLottie = lottie.loadAnimation(mobileAnimation);
    } else {
      hasLoaded = "desktop";
      dotLottie = lottie.loadAnimation(desktopAnimation);
    }

    console.log(isMobile(), mobileAnimation, desktopAnimation);

    // on resize, resize the canvas
    window.addEventListener("resize", () => {
      // if we're on mobile and the canvas is not preloaded, then preload it
      if (isMobile() && hasLoaded === "desktop") {
        lottie.destroy(dotLottie);

        dotLottie = lottie.loadAnimation(mobileAnimation);
        hasLoaded = "mobile";
      } else if (!isMobile() && hasLoaded === "mobile") {
        lottie.destroy(dotLottie);
        dotLottie = lottie.loadAnimation(desktopAnimation);

        hasLoaded = "desktop";
      }

      dotLottie.resize();
    });

    dotLottie.play();
  }

  /**
   * Services Slider
   */
  if (document.querySelector(".services__glide")) {
    const glide = new Glide(".services__glide", {
      type: "slider",
      perView: 2,
      focusAt: 0,
      animationDuration: 600,
      peek: {
        before: 0,
        after: 0,
      },
      rewind: false,
      gap: 32,
      breakpoints: {
        800: {
          perView: 1,
        },
      },
    });

    glide.mount();

    const dots = document.querySelectorAll(".services__glide .glide__bullet");

    dotsSync(glide, dots);
  }

  /**
   * Article Slider
   */
  if (document.querySelector(".articles__glide")) {
    const glide = new Glide(".articles__glide", {
      type: "slider",
      perView: 3,
      rewind: false,
      focusAt: 0,
      animationDuration: 600,
      peek: {
        before: 0,
        after: 0,
      },
      gap: 32,
      breakpoints: {
        800: {
          perView: 1,
        },
      },
    });

    glide.mount();

    const dots = document.querySelectorAll(".articles__glide .glide__bullet");

    dotsSync(glide, dots);
  }

  if (document.querySelector(".tiles__glide")) {
    const glide = new Glide(".tiles__glide", {
      type: "slider",
      perView: 1,
      focusAt: 0,
      animationDuration: 600,
      peek: {
        before: 0,
        after: 24,
      },
      rewind: false,
      gap: 32,
    });

    glide.mount();

    const dots = document.querySelectorAll(".tiles__glide .glide__bullet");

    dotsSync(glide, dots);
  }

  // clicking the .view-all button will toggle the 'open' class on the parent element
  document.querySelectorAll(".view-all").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const parent = button.closest(".article__filters");
      parent.classList.toggle("open");
      button.classList.toggle("open");
    });
  });

  // we have lazy loaded articles, if we have a .article__load-more section then
  // we need to hide the button and do a fetch when it comes into view
  function lazyLoadArticles() {
    const articleLoadMore = document.querySelector(".article__load-more");

    if (articleLoadMore) {
      const btn = articleLoadMore.querySelector(".button");

      if (btn) {
        btn.classList.add("hidden");
      }

      const articlesGrid = document.querySelector(".article__list");

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            !entry.target.classList.contains("loaded")
          ) {
            entry.target.classList.add("loaded");

            const url = btn.getAttribute("data-url");

            setTimeout(() => {
              fetch(url)
                .then((response) => response.text())
                .then((data) => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(data, "text/html");
                  const articles = doc.querySelectorAll(".insight__tile");
                  articles.forEach((article) => {
                    articlesGrid.appendChild(article);
                  });

                  // if the page has a next page then we need to update the button
                  const nextPage = doc.querySelector(".article__load-more");

                  if (nextPage) {
                    const nextUrl = nextPage
                      .querySelector(".button")
                      .getAttribute("data-url");
                    btn.setAttribute("data-url", nextUrl);
                    entry.target.classList.remove("loaded");
                  } else {
                    // remove the button
                    btn.remove();
                    articleLoadMore.remove();

                    // unobserve the articleLoadMore element
                    observer.unobserve(articleLoadMore);
                  }
                })
                .catch((error) => {
                  console.error("Error fetching articles:", error);
                });
            }, 1000);
          }
        });
      });

      observer.observe(articleLoadMore);
    }
  }

  lazyLoadArticles();

  // clicking a .button--tag should filter the articles
  function filterArticles() {
    const selectedTag = document.querySelector(
      ".article__filters--tags .active"
    );
    const keywords = document.querySelector(
      '.article__filters input[name="keywords"]'
    );
    const articlesGrid = document.querySelector(".article__list");

    const url = new URL(window.location.href);
    const tag = selectedTag ? selectedTag.getAttribute("data-tag") : null;
    const keyword = keywords ? keywords.value : null;
    if (tag && tag !== "all") {
      url.searchParams.set("tag", tag);
    } else {
      url.searchParams.delete("tag");
    }

    if (keyword) {
      url.searchParams.set("keywords", keyword);
    } else {
      url.searchParams.delete("keywords");
    }

    history.pushState({}, "", url);

    const articles = articlesGrid.querySelectorAll(".insight__tile");
    articlesGrid.classList.add("loading");

    // remove .article__empty
    const empty = articlesGrid.querySelector(".article__empty");

    if (empty) {
      empty.remove();
    }

    // remove all articles
    articles.forEach((article) => {
      article.remove();
    });

    // remove the load more section
    const articleLoadMore = document.querySelector(".article__load-more");
    if (articleLoadMore) {
      articleLoadMore.remove();
    }

    // fetch the articles
    const fetchUrl = url.toString();

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const articles = doc.querySelectorAll(".insight__tile");

        articles.forEach((article) => {
          articlesGrid.appendChild(article);
        });

        // check if the page has a next page
        const nextPage = doc.querySelector(".article__load-more");
        if (nextPage) {
          articleLoadMore.replaceWith(nextPage);
          lazyLoadArticles();
        }

        // remove the loading class
        setTimeout(() => {
          articlesGrid.classList.remove("loading");
        }, 1000);
      })
      .catch((error) => {
        console.error("Error fetching articles:", error);
      });
  }

  const tags = document.querySelectorAll(".article__filters--tags button");

  tags.forEach((tag) => {
    tag.addEventListener("click", (e) => {
      e.preventDefault();

      if (tag.classList.contains("view-all")) {
        document.querySelector(".article__filters").classList.toggle("open");
      } else {
        const parent = tag.closest(".article__filters--tags");
        const selectedTag = parent.querySelector(".active");

        if (selectedTag) {
          selectedTag.classList.remove("selected");
        }

        tag.classList.add("active");

        // remove the active class from all other tags
        tags.forEach((t) => {
          if (t !== tag) {
            t.classList.remove("active");
          }
        });

        // update the .view-all button span with the tag name
        const viewAllButton = parent.querySelector(".view-all");
        if (viewAllButton) {
          viewAllButton.querySelector("span").textContent = tag.textContent;
          viewAllButton.classList.remove("open");
        }

        // filter the articles
        filterArticles();
      }
    });
  });

  // clicking .open within .article__filters will add the open clas to the form
  const form = document.querySelector(".article__filters form");

  if (form) {
    const openButton = form.querySelector(".open");

    openButton.addEventListener("click", (e) => {
      e.preventDefault();

      if (form.classList.contains("open")) {
        // do the filtering
        filterArticles();
      } else {
        form.classList.add("open");

        // remove tabindex -1 from the close button
        const closeButton = form.querySelector(".close");

        if (closeButton) {
          closeButton.removeAttribute("tabindex");
        }

        // focus on the input
        const input = form.querySelector('input[name="keywords"]');

        if (input) {
          // remove tabindex
          input.removeAttribute("tabindex");
          input.focus();
        }
      }
    });

    const closeButton = form.querySelector(".close");
    closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      form.classList.remove("open");

      // add tabindex -1 to the input
      const input = form.querySelector('input[name="keywords"]');
      if (input) {
        input.setAttribute("tabindex", "-1");
      }

      filterArticles();

      // add tabindex -1 to the this
      closeButton.setAttribute("tabindex", "-1");
      closeButton.focus();
    });
  }

  const scrollTo = document.querySelectorAll("[data-scroll-to]");

  scrollTo.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();

      const target = document.getElementById(el.getAttribute("data-scroll-to"));

      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  // Fetch all the details element.
  const accordionBlocks = document.querySelectorAll(".accordion-block");

  accordionBlocks.forEach((accordionBlock) => {
    const detailsList = accordionBlock.querySelectorAll("details");

    // When a details is open, close all other details.
    function handleDetailToggle(event) {
      // We are only interested in details being opened.
      // Also, without the guard below, we'd run into an infinite loop.
      if (!event.target.open) return;
      for (let details of detailsList) {
        if (details === event.target) {
          details.open = !!details.open;
        }
      }
    }

    // Add toggle listeners.
    for (let details of detailsList) {
      details.addEventListener("toggle", handleDetailToggle);
    }
  });

  // clicking the .video-block__placeholder button will open the video
  const videoBlock = document.querySelector(".video-block__placeholder button");
  if (videoBlock) {
    videoBlock.addEventListener("click", (e) => {
      e.preventDefault();

      const videoWrapper = videoBlock.closest(".video-block__video");
      if (videoWrapper) {
        videoWrapper.classList.add("open");
      }

      // play the video
      const video = videoWrapper.querySelector("video");
      if (video) {
        video.play();

        // on video ended, remove the open class
        video.addEventListener("ended", () => {
          videoWrapper.classList.remove("open");
        });
      }
    });
  }

  // on submitting a form within a .form-block do it via ajax and show a success message after the form is submitted
  const formBlocks = document.querySelectorAll(".form-block");
  formBlocks.forEach((formBlock) => {
    const form = formBlock.querySelector("form");
    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();

        // check form is valid
        if (!form.checkValidity()) {
          return;
        }

        const formData = new FormData(form);
        const url = form.getAttribute("action");

        // disable the form action
        form.setAttribute("data-submitted", "true");

        // show a loading spinner
        const loading = formBlock.querySelector(".loading");
        if (loading) {
          loading.classList.remove("hidden");
        }

        fetch(url, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.text())
          .then((data) => {
            // show a success message
            const success = formBlock.querySelector(".success");
            if (success) {
              success.classList.remove("hidden");
            }

            // remove the loading spinner
            const loading = formBlock.querySelector(".loading");
            if (loading) {
              loading.classList.add("hidden");
            }

            // reset the form
            form.reset();
          })
          .catch((error) => {
            console.error("Error submitting form:", error);
          });
      });
    }
  });
});

// if esc key, close the menu
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    body.classList.remove(MENU_OPEN_CLASS);
  }
});

Pace.start();

Pace.on("done", function () {
  setTimeout(() => {
    if (body) {
      body.classList.add(BODY_LOADED_CLASS);
    }
  }, 1);
});
